<template>
  <div class="form-group" :class="{ 'has-error': errors.has(fieldId, scope) }">
    <label v-if="label">{{ label }}</label>
    <div class="date-field" :class="{'with-arrows': showArrows}">
      <button v-if="showArrows" class="btn btn-default left" type="button" @click.prevent="prev()"><i class="fa fa-chevron-left"></i></button>
      <datepicker
          :value="date"
          language="sk"
          :monday-first="true"
          @input="updateValue"
          format="dd.MM.yyyy - D"
          input-class="form-control">
      </datepicker>
      <button v-if="showArrows" class="btn btn-default right" type="button" @click.prevent="next()"><i class="fa fa-chevron-right"></i></button>
      <vue-timepicker v-if="time" v-model="timeModel" @change="timeChanged"></vue-timepicker>
    </div>
    <input type="hidden"
           :name="fieldId"
           :id="fieldId"
           :value="value"
           ref="input"
           v-validate="validation"
           data-vv-value-path="value"
           data-vv-validate-on="input">
    <p class="text-danger" v-if="errors.has(fieldId, scope)">{{ errors.first(fieldId, scope) }}</p>
  </div>


</template>

<script>
  import moment from 'moment';
  import datepicker from 'vuejs-datepicker';
  import vueTimepicker from 'vue2-timepicker'

  export default {
    components: { datepicker, vueTimepicker},
    data: () => ({
      date: null,
      timeModel: {
        HH: "00",
        mm: "00"
      }
    }),
    inject: ['$validator'],
    props: {
        value: {
            type: Object
        },
        label: {
          type: String,
          required: false
        },
        fieldId: {
          type: String,
          required: true
        },
        scope: {
          type: String,
          required: false
        },
        validation: {
          type: String,
          default: ""
        },
        showArrows: {
            type: Boolean,
            default: true
        },
        time: {
            type: Boolean,
            default: false
        }
    },
    methods: {
      updateValue(date) {
        if (!date) return;

        const mDate = moment.isMoment(date) ? date : moment(date);
        //reflect time
        mDate.set({h: Number(this.timeModel.HH), m: Number(this.timeModel.mm), s: 0, ms: 0});

        this.date = mDate.toDate();
        // this.timeChanged();
        this.$emit('input', mDate);
      },
      prev() {
        if (!this.date) this.date = new Date();
        this.updateValue(moment(this.date).subtract(1, 'd'));
      },
      next() {
        if (!this.date) this.date = new Date();
        this.updateValue(moment(this.date).add(1, 'd'));
      },
      timeChanged() {
        this.updateValue(this.date);
      }
    },
    watch: {
      value(value) {
        this.date = value ? value.toDate() : null;
        this.timeModel.HH = value.get('h') + '';
        this.timeModel.mm = value.get('m') + '';
      }
    },
    mounted() {
      this.date = this.value && moment.isMoment(this.value) ? this.value.toDate() : null;
      if (this.date) {
        const mDate = moment(this.value);
        this.timeModel.HH = _.padStart(mDate.get('h'), 2, '0');
        this.timeModel.mm = _.padStart(mDate.get('m'), 2, '0');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/form/dateField.vue